import { render, staticRenderFns } from "./ProductPurchaseForm.vue?vue&type=template&id=17316c34&scoped=true"
import script from "./ProductPurchaseForm.vue?vue&type=script&lang=js"
export * from "./ProductPurchaseForm.vue?vue&type=script&lang=js"
import style0 from "./ProductPurchaseForm.vue?vue&type=style&index=0&id=17316c34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17316c34",
  null
  
)

export default component.exports